import React, { useState, useEffect, useContext } from "react";

import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import { useParams, Link, useHistory, useLocation } from "react-router-dom";
import { BsCreditCard } from "react-icons/bs";
import { FaPiggyBank } from "react-icons/fa";
import { BsExclamationCircle } from "react-icons/bs";
import { MdContentCopy } from "react-icons/md";
import { CoinContext } from "../../../contexts/CoinContext";
import * as Sentry from "@sentry/react";
import { REACT_APP_PROD_URL } from "../../../services/configs";
import useResizer from "../../../services/useResizer";
import Icon from "../../../fontIcons/icon";
import styled from "styled-components";
import { useSelector } from "react-redux";
import qs from "query-string";
import useSWR from "swr";
import fetcher from "../../../api/swr_fetcher";

export default function INRBalanceCard(props) {
  const isMobile = useResizer();
  const classes = useStyles();
  const [inrBalance, setInrBalance] = useState(0);
  const [inrInOrder, setInrInOrder] = useState(0);

  const { handleClickAlert, bannedTimeout } = useContext(CoinContext);
  const { data, error } = useSWR(`/v1/balances/INR`, fetcher, {
    revalidateOnFocus: false,
    shouldRetryOnError: false,
  });

  useEffect(() => {
    if (data) generateData(data);
  }, [data]);

  useEffect(() => {
    if (error?.status === 401) {
      bannedTimeout("timeout");
    } else if (error?.status === 403) {
      bannedTimeout("banned");
    }
  }, [error]);

  function generateData(data) {
    if (data[0]) {
      setInrBalance(data[0].availableBalance);
      setInrInOrder(data[0].inOrderBalance);
    }
  }

  useEffect(() => {
    // if (error?.status === 401) {
    //   bannedTimeout("timeout");
    // } else if (error?.status === 403) {
    //   bannedTimeout("banned");
    // }
  }, [error]);
  return (
    <div>
      <div className="dark:bg-[#141828] bg-[#eee] p-5 ">
        <div className="sm:max-w-[50%]">
          <div className={`${classes.flexContainer} mb-3 `}>
            {/* <BsCreditCard style={{ fontSize: "20px" }} /> */}
            <Icon icon={"inr"} size={20} className="mr-2"></Icon>{" "}
            <p
              style={{
                fontSize: "16px",
                fontWeight: "bold",
              }}
            >
              INR Wallet Balance
            </p>
          </div>
          <div className="dark:bg-[#1A1F2B] p-3 rounded-lg bg-[#fff]">
            <div className={classes.flexContainer} style={{ marginTop: "5px" }}>
              <div className="w-full flex items-center justify-between">
                <p className={`${classes.ptitle}`}>Available</p>
                <p className={classes.pvalue}>
                  <Icon icon={"inr"} size={14} className="mr-1"></Icon>
                  {Number(inrBalance).toFixed(2)}
                </p>
              </div>{" "}
            </div>
            <div className={classes.flexContainer}>
              <div
                className="flex whitespace-nowrap items-center w-full justify-between"
                style={{ marginTop: "5px" }}
              >
                <p className={`${classes.ptitle}`}>In Order</p>
                <p className={classes.pvalue}>
                  <Icon icon={"inr"} size={14} className="mr-1"></Icon>
                  {Number(inrInOrder).toFixed(2)}
                </p>
              </div>
            </div>
            <div className={classes.flexContainer} style={{ marginTop: "5px" }}>
              <div className="flex whitespace-nowrap items-center w-full justify-between">
                <p className={`${classes.ptitle}`}>Total</p>
                <p className={classes.pvalue}>
                  <Icon icon={"inr"} size={14} className="mr-1"></Icon>
                  {(Number(inrBalance) + Number(inrInOrder)).toFixed(2)}
                </p>
              </div>
            </div>
          </div>
          
        </div>
        <p className="mt-3 text-xs text-pb-secondary-100">Do not Deposit INR to our OLD ICICI bank account, Always check status of INR deposit and active bank account details on this page before making a deposit</p>
      </div>
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  container: {
    flexGrow: 1,
    [theme.breakpoints.up("lg")]: {
      width: "100%",
    },
    marginLeft: "auto",
    marginRight: "auto",
  },
  grow: {
    flexGrow: 1,
  },
  link: {
    fontWeight: "bold",
    color: theme.palette.primary.text,
    paddingLeft: "10px",
    "&:hover": {
      cursor: "pointer",
      textDecoration: "underline",
    },
  },
  gridContainer: {
    background: theme.palette.type === "dark" ? "#151828" : "white",
    paddingTop: "3px",
  },
  subContainer: {
    marginTop: "15px",
    marginLeft: "20px",
    paddingBottom: "15px",
    marginRight: "15px",
  },
  flexContainer: {
    display: "flex",
    alignItems: "center",
  },
  ptitle: {
    width: "35%",
    fontSize: "16px",
    // marginLeft: "35px",
  },
  pvalue: {
    fontSize: "16px",
    fontWeight: "bold",
  },
  copyIcon: {
    fontSize: "20px",
    color: theme.palette.primary.main,
    "&:hover": {
      cursor: "pointer",
    },
  },
}));
